// src/components/view/Icon.jsx
import React from 'react';

export default function Icon({ icon, _style, size = '48px', color = 'currentColor', speed = 1 }) {
  const style = {
    fontSize: size,
    color: color
  };

  return (
    <iconify-icon
      icon={icon}
      class={_style}
      style={style}
    ></iconify-icon>
  );
}
